import './App.css';
import Chats from './Components/Chat/Chat';
// import ToolBox from './Components/ToolBox/ToolBox';

function App() {
  return (
    <div className="App">        
      <Chats/>
    </div>
  );
}

export default App;
